import { api } from '@/lib/axios';

export type ModeHeuresSup = 'PRORATA' | 'FIXE';
export type ModeGasoil = 'DEDUIT' | 'CLIENT' | 'INCLUS';

export interface LigneLocationSortante {
  id: string;
  date: string;
  journees: string;
  heures_sup: string;
  gasoil_litres: string;
  gasoil_montant: string;
  mode_gasoil: ModeGasoil | null;
  chauffeur_id: string | null;
  lieu: string | null;
  notes: string | null;
  montant: string;
  mode_gasoil_effectif: ModeGasoil;
}
export interface AvanceClient {
  id: string;
  date_avance: string;
  montant: string;
  reference: string | null;
  notes: string | null;
}
export interface LocationSortante {
  id: string;
  reference: string | null;
  engin_id: string;
  client_id: string;
  chantier_id: string | null;
  date_debut: string | null;
  date_fin: string | null;
  tarif_jour: string;
  mode_heures_sup: ModeHeuresSup;
  tarif_heure_sup: string | null;
  mode_gasoil: ModeGasoil;
  statut: string;
  facture_id: string | null;
  facture_reference: string | null;
  notes: string | null;
  lignes: LigneLocationSortante[];
  avances: AvanceClient[];
  tarif_heure_applique: string;
  total_brut: string;
  total_gasoil_deduit: string;
  total_gasoil_cout: string;
  total_avances: string;
  net_a_facturer: string;
  cout_entretien: string;
  marge: string;
}
interface Page<T> { items: T[]; total: number; page: number; size: number; pages: number }

export async function listLocationsSortantes(enginId: string): Promise<LocationSortante[]> {
  const { data } = await api.get<Page<LocationSortante>>('/locations-sortantes', { params: { engin_id: enginId, size: 200 } });
  return data.items;
}
export async function getLocationSortante(id: string): Promise<LocationSortante> {
  const { data } = await api.get<LocationSortante>(`/locations-sortantes/${id}`);
  return data;
}
export async function createLocationSortante(payload: {
  engin_id: string; client_id: string; chantier_id?: string | null; tarif_jour: string;
  date_debut?: string; date_fin?: string; mode_heures_sup?: ModeHeuresSup;
  tarif_heure_sup?: string | null; mode_gasoil?: ModeGasoil; notes?: string;
}): Promise<LocationSortante> {
  const { data } = await api.post<LocationSortante>('/locations-sortantes', payload);
  return data;
}
export async function addLigneSortante(locId: string, payload: {
  date: string; journees: string; heures_sup?: string; gasoil_litres?: string;
  gasoil_montant?: string; mode_gasoil?: ModeGasoil | null; lieu?: string; notes?: string;
}): Promise<LocationSortante> {
  const { data } = await api.post<LocationSortante>(`/locations-sortantes/${locId}/lignes`, payload);
  return data;
}
export async function deleteLigneSortante(ligneId: string): Promise<void> {
  await api.delete(`/locations-sortantes/lignes/${ligneId}`);
}
export async function addAvanceClient(locId: string, payload: { date_avance: string; montant: string; reference?: string }): Promise<LocationSortante> {
  const { data } = await api.post<LocationSortante>(`/locations-sortantes/${locId}/avances`, payload);
  return data;
}
export async function deleteAvanceClient(avanceId: string): Promise<void> {
  await api.delete(`/locations-sortantes/avances/${avanceId}`);
}
export async function validerLocationSortante(id: string): Promise<LocationSortante> {
  const { data } = await api.post<LocationSortante>(`/locations-sortantes/${id}/valider`);
  return data;
}

/** Fige le pointage SANS générer de facture (location non déclarée). */
export async function validerPointageLocationSortante(id: string): Promise<LocationSortante> {
  const { data } = await api.post<LocationSortante>(`/locations-sortantes/${id}/valider-pointage`);
  return data;
}
/** Rouvre le pointage pour correction (supprime la facture si elle est encore au brouillon). */
export async function rouvrirPointageLocationSortante(id: string): Promise<LocationSortante> {
  const { data } = await api.post<LocationSortante>(`/locations-sortantes/${id}/rouvrir`);
  return data;
}
